export default __webpack_public_path__ + "static/media/Heebo-Light.81b8083b.ttf";